import axios from 'main/common/ajax/config';
import router from 'main/router';
import {getAccessToken, setAccessToken} from 'main/utils/auth';
import {Message} from 'element-ui';
import qs from 'qs';

let refreshConfig = [];
let errorFlag = false;
// 添加请求拦截器
axios.interceptors.request.use(config => {
	if (config.method === 'get' || config.method === 'delete') {
		config.params = config.data;
	}
	if (config.url.indexOf('/authz/refreshToken') > -1) {
		// refreshtoken不需要loading状态
		return config;
	}
	refreshConfig.push(config);
	return config;
}, error => {
	return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use((response) => {
	if (response.headers.token) {
		setAccessToken(response.headers.token);
	}
	let originalConfig = response.config;
	let AccessTokenKey = 'jwt_token';
	let RefreshTokenKey = 'refresh_token';
	if (window.location.href.indexOf('login') >= 0) {
		setTimeout(function () {
			errorFlag = false;
		}, 2000);
	}
	return response;
}, (error) => {
	return Promise.reject(error);
});

// 登录的时候要form表单提交请求中多了form参数
export default {
	ajax(url, method, params, from = null) {
		return new Promise((resolve, reject) => {
			let config = null;
			// 针对文件下载，单独的头设置
			if (from && from === 'download') {
				config = {
					url: url,
					method: method,
					responseType: 'blob',
					headers: {
						'Content-type': 'application/json;charset=utf-8',
						'Accept': 'application/octet-stream'
					}
				};
			} else if (from && from !== 'download') {
				config = {
					url: url,
					method: method,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				};
				config.transformRequest = [function (data) {
					let ret = '';
					for (let it in data) {
						ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
					}
					return ret;
				}];
			} else if (!from) {
				config = {
					url: url,
					method: method,
					headers: {}
				};
				// 登录的时候检查用户后台不能传jwt_token，连传空值都不行，所以这里做了处理
				if (url.indexOf('auth/login') !== -1) {
					config.headers = {
						'Content-type': 'application/json;charset=utf-8'
					};
				} else {
					config.headers = {
						'Content-type': 'application/json;charset=utf-8',
						'token': getAccessToken()
					};
				}
			}
			config.data = params;
			axios(config).then(response => {
				// 如果是下载，就不走正常的请求判断
				if (response.headers['content-type'] === 'application/octet-stream') {
					let fileInfo = {
						name: response.headers['content-disposition'].split('=')[1],
						content: response.data
					};
					resolve(fileInfo);
				}
				// 请求接口正确且成功时
				if (response.data.status === 200) {
					resolve(response.data.result ? response.data.result : response.data);
				} else if (response.data.status === 500) {
					if(response.data.message == 'token is error') {
						reject('请重新登录');
						router.push({path: '/login'});
					}
					// 非正常错误
					if (response.data.message.indexOf('exception') > -1 || response.data.message.indexOf('Exception') > -1) {
						reject('系统异常');
					} else {
						// 请求接口错误或不成功时
						if (response.data.message) {
							reject(response.data.message);
						} else {
							// 请求接口错误或不成功时
							reject('服务器崩溃了~~~');
						}
					}
				} else if (response.data.status === 403) { // 403没有权限
					reject(response.data.message);
				} else if (response.data.status === 401 || response.data.code === 401 || (response.data.code == -1 && response.data.message === '用户jwt签名错误') || (response.data.code == -1 && response.data.message === '用户jwt过期')) {
					router.push({path: '/login'});
				} else if (response.data.status === 400 || response.data.status === 1001) {
					reject(response.data.message);
				} else {
					reject('请求失败~~~');
				}
			})
				.catch(error => {
					reject(error);
				});
		});
	}
};



// WEBPACK FOOTER //
// ./main/common/ajax/index.js